import { SIZES } from "../constants";
export default (useOnlyWindowRestrictions) => ({
    maxHeight: useOnlyWindowRestrictions
        ? window.innerHeight - SIZES.PREVIEW_WINDOW_OFFSET * 2
        : Math.min(SIZES.PREVIEW_MAX_HEIGHT, window.innerHeight - SIZES.PREVIEW_WINDOW_OFFSET * 2),
    maxWidth: useOnlyWindowRestrictions
        ? window.innerWidth - SIZES.PREVIEW_WINDOW_OFFSET * 2
        : Math.min(SIZES.PREVIEW_MAX_WIDTH, window.innerWidth - SIZES.PREVIEW_WINDOW_OFFSET * 2)
});
